<template>
  <div class="dashboard-panel p-lender-reasons">
    <div>
      <div class="panel-header">
        <h2>Top Reasons Lender was Chosen</h2>
      </div>

      <div class="panel-content">
        <Graph
          v-if="!loading"
          id="chart-lender-reasons"
          :chartData="graphData"
          :options="graphOptions"
        />
      </div>

      <div class="button-group">
        <button
          class="default-btn link small"
          @click="showCustomReasonsList = !showCustomReasonsList">
          Other Responses
          <v-icon>mdi mdi-chevron-right {{ showCustomReasonsList ? 'mdi-rotate-90' : '' }}</v-icon>
        </button>
      </div>

      <div v-if="showCustomReasonsList" class="panel-footer">
        <CustomReasonsList

          :reasons="customReviewReasons" />
      </div>
    </div>
  </div>
</template>

<script>
import CustomReasonsList from './CustomReasonsList'
import Graph from './Graph'

export default {
  name: 'PanelLenderReasons',
  components: {
    CustomReasonsList,
    Graph,
  },
  props: {
    reviews: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    loading: true,
    showCustomReasonsList: false,

    options: [
      'Reputation',
      'Rates / Terms',
      'Rejected by another lender',
      'Level of professionalism / communication received',
      'Used previously',
      'Referral',
      'Other',
    ],
    displayedOptions: [
      'Reputation',
      'Rates / Terms',
      ['Rejected by', 'another lender'],
      ['Level of professionalism /', 'communication received'],
      'Used previously',
      'Referral',
      'Other',
    ],
    barColors: [
      '#327996',
      '#194253',
      '#0096A6',
      '#B0DDF0',
      '#1F78B4',
      '#18C8DB',
      '#B4B4B4',
    ],
    graphData: {},
    graphOptions: {
      maintainAspectRatio: false,
      layout: {
        padding: {
          top: 20,
          bottom: 20,
          left: 20,
          right: 40,
        },
      },
      legend: {
        display: false,
      },
      scales: {
        xAxes: [{
          gridLines: {
            drawOnChartArea: false,
            tickMarkLength: 0,
            zeroLineWidth: 0,
          },
          ticks: {
            padding: 10,
            stepSize: 20,
            min: 0,
            max: 100,
            callback: (value) => `${value}%`,
          },
        }],
        yAxes: [{
          gridLines: {
            drawOnChartArea: false,
            tickMarkLength: 0,
            zeroLineWidth: 0,
          },
          ticks: {
            padding: 10,
            stepSize: 1,
          },
        }],
      },
      tooltips: {
        callbacks: {
          label: (tooltip, data) => {
            const sum = data.datasets[0].data.reduce((sum, val) => sum + val, 0)
            const percent = Math.round((+tooltip.value / sum) * 100)

            return `${percent}%`
          },
          title: () => null,
        },
        custom: (tooltip) => {
          tooltip.displayColors = false
        },
        xPadding: 10,
        yPadding: 10,
      },
    },
  }),

  computed: {
    customReviewReasons () {
      return this.reviews.filter(review => {
        return (
          review.reasonForChoosingLender === 'Other' &&
          review.reasonForChoosingLenderCustom
        )
      }).map(review => {
        return review.reasonForChoosingLenderCustom
      })
    },
  },

  watch: {
    reviews () { this.buildGraphData() },
  },

  mounted () {
    this.buildGraphData()
  },

  methods: {
    buildGraphData () {
      this.loading = true

      const optionIndexes = {}
      this.options.forEach((option, index) => {
        optionIndexes[option] = index
      })

      const counts = Array(this.options.length).fill(0)

      this.reviews.forEach(({ reasonForChoosingLender: reason }) => {
        const index = reason in optionIndexes
          ? optionIndexes[reason]
          : 6

        counts[index] += 1
      })

      this.graphData = {
        labels: this.displayedOptions,
        datasets: [{
          data: counts.map(count => (count / (this.reviews.length || 1)) * 100),
          barThickness: 35,
          backgroundColor: this.barColors,
          minBarLength: 5,
        }],
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-panel {
  & > div { height: auto !important; }

  .panel-header {
    padding: 0 15px;
  }

  .button-group {
    padding-left: 10px;
    justify-content: flex-start;

    button {
      padding: 0 5px;
      border-bottom: 2px solid $primaryBlue !important;
    }
  }
}

::v-deep {
  .v-icon:before {
    transition-duration: 0.3s;
    transition-property: transform;
  }
}
</style>
